import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { BehaviorSubject, Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private _httpClient = inject(HttpClient);
    private _navigation: BehaviorSubject<Navigation> = new BehaviorSubject<Navigation>(null!);


    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        return this._httpClient.get<Navigation>('api/common/navigation').pipe(
            tap((navigation) => {
                this._navigation.next(navigation);
            })
        );
    }

   
    updateNavigationBadge(itemId: string, badgeCount: number): void {
        // Get the current navigation value
        const navigation = this._navigation.getValue();

        if (navigation && badgeCount > 0) {
            // Update the navigation item with the new badge count
            const updatedNavigation = {
                ...navigation,
                default: navigation.default.map(item => {
                    if (item.id === itemId) {
                        return {
                            ...item,
                            badge: {
                                ...item.badge,
                                title: badgeCount.toString() == '' ? '0' : badgeCount.toString(), // Update badge count
                            }
                        };
                    }
                    return item;
                })
            };

            // Emit the updated navigation object
            this._navigation.next(updatedNavigation);
        } else {
            const updatedNavigation = {
                ...navigation,
                default: navigation.default.map(item => {
                    if (item.id === itemId) {
                        return {
                            ...item,
                            badge: {
                                ...item.badge,
                                title: '0', // Remove badge count
                            }
                        };
                    }
                    return item;
                })
            };

            // Emit the updated navigation object
            this._navigation.next(updatedNavigation);
        }
    }
    
}
